(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  let dataIndexes = [];
  let videoID = '';
  const url = new URL(window.location);
  const params = new URLSearchParams(window.location.search);
  const videoIdUrl = params.get('video');
  let thumbnailSwiper = null;
  let productSwiper = null;

  let myVideoLink = document.getElementById('videoLink');
  if (videoIdUrl) {
    url.searchParams.set('video', videoIdUrl);
    window.history.pushState({}, '', url);
    myVideoLink.value = url.href;
  }
  document.querySelectorAll('.video-item').forEach(slide => {
    dataIndexes.push(slide.getAttribute('data-index'));
  });

  const soundOffIcon = '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.53033 0.46967C1.23744 0.176777 0.762564 0.176777 0.469669 0.46967C0.176777 0.762563 0.176777 1.23744 0.469669 1.53033L8.06667 9.12733L7.27627 9.77401C7.09761 9.92019 6.87388 10.0001 6.64304 10.0001H2C1.44772 10.0001 1 10.4478 1 11.0001V19.0001C1 19.5523 1.44772 20.0001 2 20.0001H6.64304C6.87388 20.0001 7.09761 20.0799 7.27627 20.2261L16.3668 27.6638C17.0197 28.198 18 27.7334 18 26.8898V19.0607L28.4697 29.5303C28.7626 29.8232 29.2374 29.8232 29.5303 29.5303C29.8232 29.2374 29.8232 28.7626 29.5303 28.4697L18 16.9393V3.1103C18 2.26667 17.0197 1.80212 16.3668 2.33634L9.23339 8.17273L1.53033 0.46967ZM10.2993 9.23868L16.5 4.16542V15.4393L10.2993 9.23868ZM16.5 17.5607V25.8347L8.22613 19.0652C7.77947 18.6997 7.22014 18.5001 6.64304 18.5001H2.5V11.5001H6.64304C7.22014 11.5001 7.77948 11.3004 8.22613 10.9349L9.13262 10.1933L16.5 17.5607ZM26.6627 6.64894C26.4688 6.28292 26.0149 6.1434 25.6488 6.33732C25.2828 6.53123 25.1433 6.98515 25.3372 7.35117C26.5575 9.65448 27.2199 12.2956 27.2499 15.0001C27.2199 17.7045 26.5575 20.3456 25.3372 22.6489C25.1433 23.015 25.2828 23.4689 25.6488 23.6628C26.0149 23.8567 26.4688 23.7172 26.6627 23.3512C28 20.8269 28.7187 17.9465 28.7499 15.008L28.75 15.0001L28.7499 14.9921C28.7187 12.0536 28 9.17317 26.6627 6.64894ZM21.606 10.3618C21.9585 10.1443 22.4206 10.2536 22.6382 10.6061C23.4114 11.8589 23.7965 13.4241 23.7455 15.0001C23.7965 16.576 23.4114 18.1412 22.6382 19.394C22.4206 19.7465 21.9585 19.8558 21.606 19.6383C21.2536 19.4207 21.1442 18.9586 21.3617 18.6061C21.9677 17.6244 22.2924 16.3474 22.2455 15.0266L22.2446 15.0001L22.2455 14.9735C22.2924 13.6527 21.9677 12.3757 21.3617 11.394C21.1442 11.0415 21.2536 10.5794 21.606 10.3618Z" fill="white"></path></svg>';
  const soundOnIcon = '<svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 16.5001H5.64304C6.22014 16.5001 6.77947 16.6997 7.22613 17.0652L15.5 23.8347V2.16542L7.22613 8.93495C6.77948 9.30039 6.22014 9.50005 5.64304 9.50005H1.5V16.5001ZM5.64304 8.00005H1C0.447716 8.00005 0 8.44777 0 9.00005V17.0001C0 17.5523 0.447716 18.0001 1 18.0001H5.64304C5.87388 18.0001 6.09761 18.0799 6.27627 18.2261L15.3668 25.6638C16.0197 26.198 17 25.7334 17 24.8898V1.1103C17 0.266669 16.0197 -0.197879 15.3668 0.336337L6.27627 7.77401C6.09761 7.92019 5.87388 8.00005 5.64304 8.00005ZM24.6488 4.33732C25.0149 4.1434 25.4688 4.28292 25.6627 4.64894C27 7.17317 27.7187 10.0536 27.7499 12.9921L27.75 13.0001L27.7499 13.008C27.7187 15.9465 27 18.8269 25.6627 21.3512C25.4688 21.7172 25.0149 21.8567 24.6488 21.6628C24.2828 21.4689 24.1433 21.015 24.3372 20.6489C25.5575 18.3456 26.2199 15.7045 26.2499 13.0001C26.2199 10.2956 25.5575 7.65448 24.3372 5.35117C24.1433 4.98515 24.2828 4.53123 24.6488 4.33732ZM21.6382 8.60612C21.4206 8.25365 20.9585 8.14427 20.606 8.36184C20.2536 8.5794 20.1442 9.0415 20.3617 9.39398C20.9677 10.3757 21.2924 11.6527 21.2455 12.9735L21.2446 13.0001L21.2455 13.0266C21.2924 14.3474 20.9677 15.6244 20.3617 16.6061C20.1442 16.9586 20.2536 17.4207 20.606 17.6383C20.9585 17.8558 21.4206 17.7465 21.6382 17.394C22.4114 16.1412 22.7965 14.576 22.7455 13.0001C22.7965 11.4241 22.4114 9.85891 21.6382 8.60612Z" fill="white"></path></svg>'; 

  if (window.innerWidth <= 767) {
    function initializeThumbnailSwiper() {
      if (thumbnailSwiper) {
        thumbnailSwiper.destroy(true, true);
      }
      thumbnailSwiper = new Swiper('#list-thumbnail-videos', {
        slidesPerView: 2,
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: '.list-thumbnail-button-next',
          prevEl: '.list-thumbnail-button-prev',
        },
      });
    }
    const modal = document.getElementById('video-modal');
    const videoWrappers = document.querySelectorAll('.video-wrapper');
    const modalVideos = document.querySelectorAll('.modal-video');
    const closeModal = document.getElementById('close-modal');
    const playButtons = document.querySelectorAll('.custom-play-button');
    const shareButton = document.querySelector('.share-button');
    const sharePopup = document.querySelector('.share-popup');
    const copyBtn = document.querySelector('.copy-link-button');
    const closePopup = document.querySelector('.close-btn');
    const valueCopy = document.querySelector('#videoLink');

    let currentIndex = 0;
    let touchStartY = 0;
    let touchCurrentY = 0;
    let isDragging = false;
    let translateY = 0;
    let lastTouchY = 0;
    let lastTouchTime = 0;
    let velocity = 0;
    const videoHeight = window.innerHeight;
    const threshold = videoHeight / 5;
    const velocityThreshold = 0.5;

    function showModal(index) {
      currentIndex = index;
      modal.classList.remove('hidden');
      document.body.classList.add('no-scroll');
      videoWrappers.forEach((wrapper, i) => {
        const video = wrapper.querySelector('video');
        const playBtn = wrapper.querySelector('.custom-play-button');
        wrapper.classList.toggle('active', i === index);
        wrapper.style.transform = `translateY(${(i - index) * 100}%)`;
        if (i === index) {
          video.currentTime = 0;
          video.play();
          playBtn.style.display = 'none';
        } else {
          video.pause();
          playBtn.style.display = 'block';
        }
      });
      if (productSwiper) {
        productSwiper.slideTo(index);
      }
      initializeVariantSlider(index);
      translateY = -index * videoHeight;
    }

    function closeModalHandler() {
      document.body.classList.remove('no-scroll');
      modal.classList.add('hidden');
      modalVideos.forEach(video => video.pause());
      initializeThumbnailSwiper();
    }

    function initializeVariantSlider(index) { 
      const detail = document.querySelectorAll('.product-detail')[index];
      if (!detail) return;

      const variantsGrid = detail.querySelector('.variants-grid');
      if (!variantsGrid) return;

      if (variantsGrid.querySelectorAll('.swiper-slide').length === 0) {
        variantsGrid.innerHTML = '<p>No variants available</p>';
        return;
      }

      // NEW Ensure variants grid is visible immediately
      // variantsGrid.classList.add('show');
      // const parent = variantsGrid.closest('.product-info');
      // if (parent) {
      //   parent.classList.add('showPagination');
      //   parent.classList.remove('hiddenPagination');
      // }
      // NEW Ensure variants grid is visible immediately
    
      if (variantsGrid.swiper) {
        variantsGrid.swiper.destroy(true, true);
        variantsGrid.classList.remove('swiper-initialized');
      }
      
      const variantSwiper = new Swiper(variantsGrid, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        centeredSlides: false,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        pagination: {
          el: '.variants-pagination',
          clickable: true,
        },
        touchReleaseOnEdges: true,
        threshold: 5,
        touchRatio: 1,
        touchAngle: 45,
        resistanceRatio: 0,
        simulateTouch: true,
        touchStartForcePreventDefault: false,
        grabCursor: true,
        passiveListeners: false,
        on: {
          init: function () {
            this.slideTo(0, 0, false);
          },
          touchStart: function (e) {
            if (e.originalEvent) {
              e.originalEvent.stopPropagation();
            }
          },
          touchMove: function (e) {
            if (e.originalEvent) {
              e.originalEvent.stopPropagation();
            }
          },
          touchEnd: function (e) {
            if (e.originalEvent) {
              e.originalEvent.stopPropagation();
            }
          },
          slideChange: function () {
            console.log('Variants-grid slide changed to index:', this.activeIndex);
          },
          snapIndexChange: function () {
            console.log('Variants-grid snapped to index:', this.snapIndex);
          },
        },
      });
      variantsGrid.classList.add('swiper-initialized');
      // xem all product
      const viewAllButtons = variantsGrid.querySelector('.view-all-products-btn');
      const toggleBtn = detail.querySelector('.variants-toggle-btn');
      const variantWrapper = variantsGrid.querySelector('.variant-wrapper');
      if (toggleBtn && variantWrapper) {
        if (!toggleBtn.classList.contains('btn-variants-visible') && !toggleBtn.classList.contains('btn-variants-hidden')) {
          toggleBtn.classList.add('btn-variants-visible');
        }
        if (!variantWrapper.classList.contains('show') && !variantWrapper.classList.contains('hidden')) {
          variantWrapper.classList.add('show');
        }

        const arrowUp = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 11L9 6L14 11" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
        const arrowDown = '<svg width="28" height="28" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 7L9 12L4 7" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path>'
        toggleBtn.removeEventListener('click', toggleBtn.clickHandler);
        toggleBtn.clickHandler = (e) => {
          e.stopPropagation();
          const isVisible = toggleBtn.classList.contains('btn-variants-visible');
          if (isVisible) {
            toggleBtn.classList.remove('btn-variants-visible');
            toggleBtn.classList.add('btn-variants-hidden');
            viewAllButtons.classList.remove('btn-viewall-visible');
            viewAllButtons.classList.add('btn-viewall-hidden');            
            variantWrapper.classList.remove('show');
            variantWrapper.classList.add('hidden');
            toggleBtn.innerHTML = arrowUp
            const parent = variantsGrid.closest('.product-info');
            if (parent) {
              parent.classList.remove('showPagination');
              parent.classList.add('hiddenPagination');
            }
          } else {
            toggleBtn.classList.remove('btn-variants-hidden');
            toggleBtn.classList.add('btn-variants-visible');
            viewAllButtons.classList.remove('btn-viewall-hidden');
            viewAllButtons.classList.add('btn-viewall-visible');
            toggleBtn.innerHTML = arrowDown
            variantWrapper.classList.remove('hidden');
            variantWrapper.classList.add('show');
            const parent = variantsGrid.closest('.product-info');
            if (parent) {
              parent.classList.remove('hiddenPagination');
              parent.classList.add('showPagination');
            }
          }
        };
        toggleBtn.addEventListener('click', toggleBtn.clickHandler);
      }
      
      // poup
      const variantsPopup = document.getElementById('product-variants-popup');
      const variantsContent = variantsPopup.querySelector('.product-variants-content');
      const closePopupBtn = variantsPopup.querySelector('.popup-close-btn');   
      if (viewAllButtons) {
        viewAllButtons.addEventListener('click', (e) => {
          e.stopPropagation();
          const productDetail = viewAllButtons.closest('.product-detail');
          const productLink = productDetail.querySelector('.product-link');
          const productImg = productLink.querySelector('img').getAttribute('src');
          const productTitle = productLink.querySelector('.product-title').textContent;
          const productPrice = productLink.querySelector('.price').textContent;
          const variants = productDetail.querySelectorAll('.variant-card');

          let variantsHTML = `
            <div class="product-main-info">
              <img src="${productImg}" alt="${productTitle}">
              <div class="product-text">
                <p class="product-title">${productTitle}</p>
                <p class="price">${productPrice}</p>
              </div>
            </div>
            <div class="variants-grid-popup">`;

          variants.forEach(variant => {
            const variantImg = variant.querySelector('img').getAttribute('src');
            const variantTitle = variant.querySelector('.variant-title').textContent;
            const variantPrice = variant.querySelector('.price').textContent;
            const variantLink = variant.querySelector('.shop-now-button').getAttribute('href');

            variantsHTML += `
              <div class="variant-card">
                <img src="${variantImg}" alt="${variantTitle}">
                <p class="variant-title">${variantTitle}</p>
                <p class="variant-price">${variantPrice}</p>
                <a href="${variantLink}" class="shop-now-button">Shop Now</a>
              </div>
            `;
          });

          variantsHTML += `</div>`;
          variantsContent.innerHTML = variantsHTML;
          variantsPopup.classList.remove('hidden');
          document.body.classList.add('no-scroll');
        });
      }

      closePopupBtn.addEventListener('click', (e) => {
        variantsPopup.classList.add('hidden');
        document.body.classList.remove('no-scroll');
      });
      
      const video = modalVideos[index]; // detail.querySelector('.product-video');
      if (video) {
        let hasShown = false;

        video.play().catch(error => {
          setTimeout(() => {
            if (!hasShown) {
              variantsGrid.classList.add('show');
              variantsGrid.classList.remove('hidden');
              const parent = variantsGrid.closest('.product-info');
              if (parent) {
                parent.classList.add('showPagination');                
                parent.classList.remove('hiddenPagination');
              }
              hasShown = true;
            }
          }, 3000);
        });

        const timeUpdateHandler = () => {
          if (video.currentTime >= 3 && !hasShown) {
            variantsGrid.classList.add('show');
            variantsGrid.classList.remove('hidden');
            const parent = variantsGrid.closest('.product-info');
            if (parent) {
              parent.classList.add('showPagination');              
              parent.classList.remove('hiddenPagination');
            }         
            hasShown = true;
            video.removeEventListener('timeupdate', timeUpdateHandler);
          }
        };
        video.addEventListener('timeupdate', timeUpdateHandler);

        video.addEventListener('seeking', () => {    
          if (video.currentTime < 3 && hasShown) {
            variantsGrid.classList.remove('show');
            variantsGrid.classList.add('hidden');
            const parent = variantsGrid.closest('.product-info');
            if (parent) {
              parent.classList.remove('showPagination');             
              parent.classList.add('hiddenPagination');
            }
            hasShown = false;
            video.addEventListener('timeupdate', timeUpdateHandler);
          }
        });
      } else {
        setTimeout(() => {
          variantsGrid.classList.add('show');
          variantsGrid.classList.remove('hidden');
          const parent = variantsGrid.closest('.product-info');
          if (parent) {
            parent.classList.add('showPagination');            
            parent.classList.remove('hiddenPagination');
          }
        }, 3000);
      }     
    }

    function initializeProductSwiper() {
      if (productSwiper) {
        productSwiper.destroy(true, true);
      }
      productSwiper = new Swiper('.product-info', {
        slidesPerView: 1,
        spaceBetween: 10,
        touchRatio: 0,
        simulateTouch: false,
        on: {
          init: function () {
            if (videoIdUrl) {
              const index = dataIndexes.indexOf(videoIdUrl);
              if (index !== -1) {
                this.slideTo(index, 0, false);
              }
            }
          },
          slideChange: function() {
            const newIndex = this.activeIndex;
            if (newIndex !== currentIndex) {
              const nextID = dataIndexes[newIndex];
              url.searchParams.set('video', nextID);
              window.history.pushState({}, '', url);
              myVideoLink.value = url.href;
              showModal(newIndex);
            }
          },
          touchStart: function (e) {
            if (e.target && e.target.closest && e.target.closest('.variants-grid')) {
              e.stopPropagation();
              return false;
            }
          },
          touchMove: function (e) {
            if (e.target.closest('.variants-grid')) {
              e.stopPropagation();
              return false;
            }
          },
          touchEnd: function (e) {
            if (e.target && e.target.closest && e.target.closest('.variants-grid')) {
              e.stopPropagation();
              return false;
            }
          },
        },
      });
    }

    document.querySelectorAll('.video-item').forEach(item => {
      item.addEventListener('click', () => {
        videoID = item.getAttribute('data-index');
        url.searchParams.set('video', videoID);
        window.history.pushState({}, '', url);
        myVideoLink.value = url.href;
        const index = dataIndexes.indexOf(videoID);
        showModal(index);
      });
    });

    closeModal.addEventListener('click', closeModalHandler);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeModalHandler();
      }
    });

    modalVideos.forEach((video, index) => {
      const playBtn = playButtons[index];
      const wrapper = video.closest('.video-wrapper');
      const overlay = wrapper.querySelector('.unmute-overlay');
      const unmuteBtn = overlay.querySelector('.unmute-button');
      const muteToggle = wrapper.querySelector('.mute-toggle');

      video.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          playBtn.style.display = 'none';
        } else {
          video.pause();
          playBtn.style.display = 'block';
        }
      });

      video.addEventListener('ended', () => {
        const nextIndex = (index + 1) % videoWrappers.length;
        const nextID = dataIndexes[nextIndex];
        url.searchParams.set('video', nextID);
        window.history.pushState({}, '', url);
        myVideoLink.value = url.href;
        const myModalVideo = video.closest('.modal-content')
        if (myModalVideo) {
          const productDiv = myModalVideo.querySelector('.product-info');
          if (productDiv) {
            productDiv.classList.remove('showPagination');
          }
        }
        showModal(nextIndex);
      });

      playBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        video.play();
        playBtn.style.display = 'none';
      });

      video.muted = true;
      const unmutedBefore = localStorage.getItem('hasUnmutedOnce') === 'true';
      if (!unmutedBefore) {
        overlay.style.display = 'block';
      } else {
        overlay.style.display = 'none';
      }
      unmuteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        video.muted = false;
        overlay.style.display = 'none';
        localStorage.setItem('hasUnmutedOnce', 'true');
        muteToggle.innerHTML = soundOnIcon;
      });
      video.addEventListener('volumechange', () => {
        if (!video.muted) {
          overlay.style.display = 'none';
          localStorage.setItem('hasUnmutedOnce', 'true');
        }
      });

      muteToggle.innerHTML = video.muted ? soundOffIcon : soundOnIcon;
      muteToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        video.muted = !video.muted;
        muteToggle.innerHTML = video.muted ? soundOffIcon : soundOnIcon;
      });
    });

    videoWrappers.forEach(wrapper => {
      wrapper.style.display = 'block';
    });

    modal.addEventListener('touchstart', (e) => {
      if (e.target.closest('.variants-grid')) return;
      const touchY = e.changedTouches[0].clientY;
      const productInfo = document.querySelector('.product-info');      
      const productInfoRect = productInfo.getBoundingClientRect();
      if (touchY > productInfoRect.top && touchY < productInfoRect.bottom) return;
 
      touchStartY = e.changedTouches[0].screenY;
      touchCurrentY = touchStartY;
      lastTouchY = touchStartY;
      lastTouchTime = performance.now();
      isDragging = true;
      videoWrappers.forEach(wrapper => {
        wrapper.style.transition = 'none';
      });
    });

    modal.addEventListener('touchmove', (e) => {
      if (e.target.closest('.variants-grid')) return;

      if (e.target.closest('.product-variants-popup')) return;
      if (!isDragging) return;
      touchCurrentY = e.changedTouches[0].screenY;
      const currentTime = performance.now();
      const deltaY = touchCurrentY - lastTouchY;
      const deltaTime = currentTime - lastTouchTime;

      if (deltaTime > 0) {
        velocity = deltaY / deltaTime;
      }

      translateY = -currentIndex * videoHeight + (touchCurrentY - touchStartY);

      videoWrappers.forEach((wrapper, i) => {
        const offset = (i - currentIndex) * videoHeight + (touchCurrentY - touchStartY);
        wrapper.style.transform = `translateY(${offset}px)`;
      });

      lastTouchY = touchCurrentY;
      lastTouchTime = currentTime;
    });

    modal.addEventListener('touchend', (e) => {
      if (e.target.closest('.variants-grid')) return;
      
      if (!isDragging) return;
      isDragging = false;
      const deltaY = touchCurrentY - touchStartY;
      const absVelocity = Math.abs(velocity);

      let newIndex = currentIndex;
      if (deltaY < -threshold || (absVelocity > velocityThreshold && velocity < 0)) {
        newIndex = Math.min(currentIndex + 1, videoWrappers.length - 1);
      } else if (deltaY > threshold || (absVelocity > velocityThreshold && velocity > 0)) {
        newIndex = Math.max(currentIndex - 1, 0);
      }
      
      if (newIndex !== currentIndex) {
        const productInfo = document.querySelector('.product-info');
        productInfo.classList.remove('showPagination');
        const nextID = dataIndexes[newIndex];
        url.searchParams.set('video', nextID);
        window.history.pushState({}, '', url);
        myVideoLink.value = url.href;
        showModal(newIndex);
      } else {
        videoWrappers.forEach((wrapper, i) => {
          wrapper.style.transition = 'transform 0.3s ease-out';
          wrapper.style.transform = `translateY(${(i - currentIndex) * 100}%)`;
        });
      }

      velocity = 0;
    });

    shareButton.addEventListener('click', (e) => {
      e.stopPropagation();
      sharePopup.classList.remove('hidden');
      const shareURL = valueCopy.value;
      document.querySelector('.twitter').href = `https://x.com/intent/tweet?source=tweetbutton&url=${encodeURIComponent(shareURL)}`;
      document.querySelector('.facebook').href = `https://www.facebook.com/share_channel/?type=reshare&link=${encodeURIComponent(shareURL)}`;
      document.querySelector('.linkedin').href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareURL)}`;
      document.querySelector('.messenger').href = `fb-messenger://share?link=${encodeURIComponent(shareURL)}`;
      document.querySelector('.whatsapp').href = `https://wa.me/?text=${encodeURIComponent(shareURL)}`;
    });

    copyBtn.addEventListener('click', () => {
      valueCopy.select();
      document.execCommand('copy');
      copyBtn.textContent = 'Link copied';
      setTimeout(() => (copyBtn.textContent = 'Copy link'), 2000);
    });

    closePopup.addEventListener('click', () => {
      sharePopup.classList.add('hidden');
    });

    document.addEventListener('click', (e) => {
      if (!sharePopup.contains(e.target) && !shareButton.contains(e.target)) {
        sharePopup.classList.add('hidden');
      }
    });

    if (videoIdUrl) {
      const index = dataIndexes.indexOf(videoIdUrl);
      if (index !== -1) {
        initializeProductSwiper();
        showModal(index);
        initializeVariantSlider(index); 
      }
    }

    initializeThumbnailSwiper();
    initializeProductSwiper();
  } else {
    // Desktop code remains unchanged
    const modal = document.getElementById('video-modal');
    const videoWrappers = document.querySelectorAll('.video-wrapper');
    const modalVideos = document.querySelectorAll('.modal-video');
    const productDetails = document.querySelectorAll('.product-detail');
    const closeModal = document.getElementById('close-modal');
    const playButtons = document.querySelectorAll('.custom-play-button');

    function showModal(curentIndex) {
      modal.classList.remove('hidden');
      document.body.classList.add('no-scroll');
      videoWrappers.forEach((wrapper, i) => {
        const video = wrapper.querySelector('video');
        const playBtn = wrapper.querySelector('.custom-play-button');
        wrapper.style.top = `${(i - curentIndex) * 100}%`;
        if (i == curentIndex) {
          video.currentTime = 0;
          video.play();
          playBtn.style.display = 'none';
        } else {
          video.pause();
          playBtn.style.display = 'block';
        }
      });

      productDetails.forEach((detail, i) => {
        detail.classList.toggle('active', i == curentIndex);
      });

      setTimeout(() => {
        const swiperInstance = document.querySelector('.video-swiper')?.swiper;
        if (swiperInstance) {
          swiperInstance.slideTo(curentIndex);
        }
      }, 100);

      document.querySelectorAll('.video-thumb').forEach((thumb, i) => {
        thumb.classList.toggle('active-thumb', i == curentIndex);
      });
    }

    document.querySelectorAll('.video-item, .video-thumb').forEach(item => {
      item.addEventListener('click', () => {
        videoID = item.getAttribute('data-index');
        url.searchParams.set('video', videoID);
        window.history.pushState({}, '', url);
        myVideoLink.value = url.href;
        const currentIndex = dataIndexes.indexOf(videoID);
        showModal(currentIndex);
      });
    });

    if (videoIdUrl) {
      const currentIndex = dataIndexes.indexOf(videoIdUrl);
      showModal(currentIndex);
    }

    closeModal.addEventListener('click', () => {
      document.body.classList.remove('no-scroll');
      modal.classList.add('hidden');
      modalVideos.forEach(video => video.pause());
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.body.classList.remove('no-scroll');
        modal.classList.add('hidden');
        modalVideos.forEach(video => video.pause());
      }
    });

    modalVideos.forEach((video, index) => {
      const playBtn = playButtons[index];
      video.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          playBtn.style.display = 'none';
        } else {
          video.pause();
          playBtn.style.display = 'block';
        }
      });

      video.addEventListener('ended', () => {
        const nextIndex = (index + 1) % videoWrappers.length;
        const nextID = dataIndexes[nextIndex];
        url.searchParams.set('video', nextID);
        window.history.pushState({}, '', url);
        myVideoLink.value = url.href;
        videoWrappers[index].classList.remove('active');
        videoWrappers[nextIndex].classList.add('active');
        setTimeout(() => {
          showModal(nextIndex);
        }, 300);
      });

      playButtons.forEach((btn, index) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const video = modalVideos[index];
          video.play();
          btn.style.display = 'none';
        });
      });

      video.muted = true;
      const wrapper = video.closest('.video-wrapper');
      const overlay = wrapper.querySelector('.unmute-overlay');
      const unmuteBtn = wrapper.querySelector('.unmute-button');
      const unmutedBefore = localStorage.getItem('hasUnmutedOnce') === 'true';
      if (!unmutedBefore) {
        overlay.style.display = 'block';
      } else {
        video.muted = true;
        overlay.style.display = 'none';
      }
      unmuteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        video.muted = false;
        overlay.style.display = 'none';
        localStorage.setItem('hasUnmutedOnce', 'true');
        const wrapper = video.closest('.video-wrapper');
        const muteToggle = wrapper.querySelector('.mute-toggle');
        muteToggle.innerHTML = soundOnIcon;
      });
      video.addEventListener('volumechange', () => {
        if (!video.muted) {
          overlay.style.display = 'none';
          localStorage.setItem('hasUnmutedOnce', 'true');
        }
      });
    });

    new Swiper('.video-swiper', {
      direction: 'vertical',
      slidesPerView: 3,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-video-list-button-next',
        prevEl: '.swiper-video-list-button-prev',
      },
      mousewheel: window.innerWidth >= 768,
      freeMode: true,
    });

    document.querySelectorAll('.mute-toggle').forEach((btn, index) => {
      const video = modalVideos[index];
      btn.innerHTML = video.muted ? soundOffIcon : soundOnIcon;
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        video.muted = !video.muted;
        btn.innerHTML = video.muted ? soundOffIcon : soundOnIcon;
      });
    });

    new Swiper('#list-thumbnail-videos', {
      slidesPerView: 4,
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: '.list-thumbnail-button-next',
        prevEl: '.list-thumbnail-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 8,
        },
        520: {
          slidesPerView: 2,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
      }
    });
  }

  const shareButtons = document.querySelector('.share-button');
  const sharePopup = document.querySelector('.share-popup');
  const copyBtn = document.querySelector('.copy-link-button');
  const valueCopy = document.querySelector('#videoLink');
  const closePoup = document.querySelector('.close-btn');

  shareButtons.addEventListener('click', (e) => {
    e.stopPropagation();
    sharePopup.classList.remove('hidden');
    const shareURL = valueCopy.value;
    document.querySelector('.twitter').href = `https://x.com/intent/tweet?source=tweetbutton&url=${encodeURIComponent(shareURL)}`;
    document.querySelector('.facebook').href = `https://www.facebook.com/share_channel/?type=reshare&link=${encodeURIComponent(shareURL)}`;
    document.querySelector('.linkedin').href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareURL)}`;
    document.querySelector('.messenger').href = `fb-messenger://share?link=${encodeURIComponent(shareURL)}`;
    document.querySelector('.whatsapp').href = `https://wa.me/?text=${encodeURIComponent(shareURL)}`;
    const rect = shareButtons.getBoundingClientRect();
    sharePopup.style.top = `${rect.bottom + window.scrollY + 5}px`;
    sharePopup.style.left = `${rect.left + window.scrollX}px`;
  });

  copyBtn.addEventListener('click', () => {
    valueCopy.select();
    document.execCommand('copy');
    copyBtn.textContent = 'Link copied';
    setTimeout(() => (copyBtn.textContent = 'Copy link'), 2000);
  });

  closePoup.addEventListener('click', () => {
    sharePopup.classList.add('hidden');
  });

  document.addEventListener('click', (e) => {
    if (!sharePopup.contains(e.target)) {
      sharePopup.classList.add('hidden');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
